var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"display":"inline","margin":"0"}},[_vm._v("PEPSI reduced spectra")])}
var staticRenderFns = []

export { render, staticRenderFns }